<template>
    <div>
        <b-table
            :empty-text="$t('there_are_no_records')"
            bordered
            striped
            responsive
            :items="cateringRequests"
            :fields="fields"
            show-empty
            class="mb-5 table-dropdown no-scrollbar border rounded"
        >
            <template #cell(actions)="data">
                <b-dropdown
                    no-caret
                    right
                    variant="link"
                    toggle-class="p-0 text-muted"
                >
                    <template #button-content>
                        <i class="ri-more-fill"></i>
                    </template>

                    <b-dropdown-item @click="$router.push('/catering/request/' + data.item.id)">
                        <i class="ri-eye-line mr-2 text-primary"></i>{{ $t('detail') }}
                    </b-dropdown-item>
                </b-dropdown>
            </template>
        </b-table>
    </div>
</template>

<script>
import CateringRequestService from "@/services/CateringRequestService";
import qs from "qs";

export default {
    name: "CateringRequest",
    props: {
        filter: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            cateringRequests: [],
            fields: [
                { key: "actions", label: "", tdClass: "text-center" },
                { key: "event_label", label: this.toUpperCase("event") },
                { key: "audience_label", label: this.toUpperCase("audience") },
                { key: "event_location", label: this.toUpperCase("event_location") },
                { key: "event_date", label: this.toUpperCase("event_date") },
                { key: "guest_count", label: this.toUpperCase("guest_count") },
                { key: "budget", label: this.toUpperCase("budget") },
                { key: "status_name", label: this.toUpperCase("status") },
                { key: "created_at", label: this.toUpperCase("created_at") },
            ],
        };
    },
    created() {
        this.getData();
    },
    methods: {
        async getData() {
            const config = {
                ...this.filter,
                paramsSerializer: (params) => qs.stringify(params, { encode: false }),
            };
            try {
                const response = await CateringRequestService.getMyRequests(config);
                this.cateringRequests = response.data.data;
            } catch (e) {
                this.showErrors(e);
            }
        },
    },
};
</script>
